import store from '../store'
import toast from '../plugins/izitoast'
import LiveNotification from './LiveNotification'
import EventBus from '../plugins/event-bus'

const signalR = require('./../../node_modules/@aspnet/signalr/dist/browser/signalr')

class SignalR {
    apiBaseURL = null
    connection = null

    constructor () {
        this.apiBaseURL = process.env.VUE_APP_API_SIGNALR_HOST
    }

    connect () {
        this.connection = new signalR.HubConnectionBuilder()
            .withUrl(`${this.apiBaseURL}/notifications`, {
                accessTokenFactory: () => {
                    return store.state.token
                },
                transport: 1
            })
            .configureLogging(signalR.LogLevel.Information)
            .build()

        this.connection.connection.onclose(() => {
            console.info('Disconnected')
        })

        return this
    }

    handleSnapshots () {
        this.connection.on('SnapshotProcessed', (messages) => {
            messages.forEach(message => {
                message.snapshotType = store.state.snapshotTypes.find(event => {
                    return event.id === message.type
                })

                toast.snapshot(message)
            })
        })

        return this
    }

    handleEvents () {
        this.connection.on('NewEvent', (messages) => {
            // messages.forEach(message => {
            //     const eventType = store.state.eventTypes.find(event => {
            //         return event.id === message.type
            //     })
            //
            //     message.eventType = eventType
            //     toast.event(message)
            // })
        })

        return this
    }

    handleLiveView () {
        this.connection.on('LiveView', (message) => {
            EventBus.$emit('live-view', message)
            return message
        })

        return this
    }

    handleRemotePlayback () {
        this.connection.on('RemotePlayback', (message) => {
            EventBus.$emit('remote-playback', message)
            return message
        })

        return this
    }

    handleRemotePlaybackCalendar () {
        this.connection.on('RemotePlaybackRecordingCalendar', (message) => {
            EventBus.$emit('remote-playback-calendar', message)
            return message
        })

        return this
    }

    handleRemotePlaybackAvailableVideos () {
        this.connection.on('RemotePlaybackAvailableVideos', (message) => {
            EventBus.$emit('remote-playback-available-videos', message)
            return message
        })

        return this
    }

    stopHandleEvents () {
        // this.connection.off('newevent')

        return this
    }

    async startListen () {
        await this.connection.start()

        let hub = this.connection

        if (!hub['connection'].transport.hasOwnProperty('webSocket')) {
            toast.error('Failed SignalR connection')
            return this
        }

        let connectionUrl = new URL(hub['connection'].transport.webSocket.url)
        store.state.connectionId = connectionUrl.searchParams.get('id')

        await LiveNotification.subscribe(store.state.connectionId)
    }

    disconnect () {
        this.connection.stop()

        return this
    }
}

const signalObject = new SignalR()
signalObject.connect()

export default signalObject
